export default "__VITE_ASSET__BU0PILhV__"